/*eslint no-console: 0*/

import http from './httpSaga';
import {toastr} from 'react-redux-toastr';
import {put} from 'redux-saga/effects';

export const $param = '##PARAM';

/** Utility function for unwrapping http response */
export function unwrap(response) {
  if (response instanceof Error) {
    toastr.error('Une erreur a eu lieu');
    console.error('HTTP Error :', response);
    console.trace();
    return false;
  } else {
    return true;
  }
}


/**
 * Returns a generator for get queries
 * @param urlTemplate {string} Url with templated args or not
 * @param success {Function} (response, parent) called on query success
 * @param failure {Function} (response, parent) called on query failure
 * @param getParams {Object} Fixed (value) or dynamic ($param) GET params KV
 * @returns {Function} Get queries generator
 */
export function $index(urlTemplate, success, failure, getParams = {}) {
  return function*({parent, params}) {
    let response;
    let url = urlTemplate;
    if (url.indexOf('#{parent}') !== -1) {
      if (!parent || parent.id === null || parent.id === undefined) {
        yield put(failure(new Error('Missing parent object on parent call')));
        return;
      }
      url = url.replace('#{parent}', '' + parent.id);
    }
    let getParamsString = Object.keys(getParams).map(name => {
      const value = getParams[name];
      if (value === $param) {
        return [name, params[name]].join('=');
      } else {
        return [name, value].join('=');
      }
    }).join('&');

    if (getParamsString.length > 0) {
      url = url + '?' + getParamsString;
    }

    response = yield http.json.get(url);

    if (unwrap(response)) {
      yield put(success(response, parent));
    } else {
      yield put(failure(response, parent));
    }
  }
}


/**
 * Returns a generator for delete queries
 * @param urlTemplate {string} Url with templated args or not
 * @param success {Function} (response, parent) called on query success
 * @param failure {Function} (response, parent) called on query failure
 * @returns {Function} Delete queries generator
 */
export function $delete(urlTemplate, success, failure) {
  return function*({id}) {
    let url = urlTemplate.replace('#{id}', '' + id);
    let response = yield http.delete(url);

    if (unwrap(response)) {
      yield put(success(id));
    } else {
      yield put(failure(null, response));
    }
  }
}


/**
 * Returns a generator for post queries
 * @param urlTemplate {string} Url with templated args or not
 * @param success {Function} (response, parent) called on query success
 * @param failure {Function} (response, parent) called on query failure
 * @returns {Function} Post queries generator
 */
export function $post(urlTemplate, success, failure) {
  return function*({payload}) {
    let response;
    response = yield http.json.post(urlTemplate, payload);

    if (unwrap(response)) {
      yield put(success(response));
    } else {
      yield put(failure(payload, response));
    }
  }
}


/**
 * Returns a generator for put queries
 * @param urlTemplate {string} Url with templated args or not
 * @param success {Function} (response, parent) called on query success
 * @param failure {Function} (response, parent) called on query failure
 * @returns {Function} Put queries generator
 */
export function $put(urlTemplate, success, failure) {
  return function*({payload}) {
    let response;
    let url = urlTemplate.replace('#{id}', payload.id);
    response = yield http.json.put(url, payload);

    if (unwrap(response)) {
      yield put(success(response));
    } else {
      yield put(failure(payload, response));
    }
  }
}



// WEBPACK FOOTER //
// ./src/redux/_utils/restSaga.js